// ** Initial State
const initialState = {
  eventFilter: {},
};

const eventFilter = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_EVENT_FILTER':
      return {
        ...state,
        eventFilter: action.eventFilter,
      };
    // Must return the same reference: redux-persist only rehydrates a slice
    // whose reducer leaves it untouched on REHYDRATE.
    default:
      return state;
  }
};

export default eventFilter;
